module.exports = __webpack_public_path__ + "static/media/whatsapp.07918c69.svg";